import { loadStripe, type Stripe } from '@stripe/stripe-js';

// One Stripe.js instance per publishable key, cached across the session so we
// never re-download stripe.js for the same key.
const _cache = new Map<string, Promise<Stripe | null>>();

export function getStripe(publishableKey: string): Promise<Stripe | null> {
  let promise = _cache.get(publishableKey);

  if (!promise) {
    promise = loadStripe(publishableKey);
    _cache.set(publishableKey, promise);
  }

  return promise;
}
